// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import "lib-flexible/flexible";

// import VConsole from "vconsole";
// const vConsole = new VConsole();
// vConsole.destroy();

Vue.use(ElementUI);

import axios from "axios";
Vue.prototype.$axios = axios;
var interceptLogin = axios.create({
  // baseURL: "https://jk-xs.yemast.com:8007"
  // baseURL: "https://cqc-server-zuul.jsti-smart.cn"
  baseURL: "https://open.ys7.com/api/lapp"
});

Vue.prototype.$http = interceptLogin;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js